import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["itemsList", "itemTemplate", "price", "quantity"]

    addItem(event) {
        event.preventDefault()

        const content = this.itemTemplateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
        this.itemsListTarget.insertAdjacentHTML('beforeend', content)
    }

    removeItem(event) {
        event.preventDefault()

        const wrapper = event.target.closest('[data-new-record]')

        if (wrapper.dataset.newRecord === "true") {
            wrapper.remove()
        } else {
            wrapper.style.display = 'none'
            wrapper.querySelector("input[name*='_destroy']").value = 1
        }
    }

    productChanged(event) {
        const select = event.target
        const selectedOption = select.options[select.selectedIndex]
        const wrapper = select.closest('[data-new-record]')

        if (selectedOption && selectedOption.value) {
            const price = selectedOption.dataset.price

            // Find inputs within this item's wrapper
            const priceInput = wrapper.querySelector("input[name*='[unit_price_cents]']")
            const quantityInput = wrapper.querySelector("input[name*='[quantity]']")

            if (priceInput) priceInput.value = price
            if (quantityInput && !quantityInput.value) quantityInput.value = 1
        }
    }
}
